import styled from 'styled-components';
import Popup from 'reactjs-popup';

export const Wrapper = styled.div``;

export const PopupStyled = styled(Popup)`
  &-overlay {
    background: transparent;
  }

  &-content {
    color: #161643;
    padding: 8px 0 16px;
    z-index: 99999;
    min-width: 295px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    border-radius: 0 0 12px 12px;
    background: #ffffff;
    box-shadow: 3px 3px 10px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const Option = styled.div`
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 4px 16px;
  width: 100%;
  background: #fff;

  &:hover {
    color: #fff;
    background: #2148ff;
    transition: all ease-in-out 0.1s;
  }
`;
